import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1rem;
  padding: 0.5rem 2rem;
  font-size: 0.9em;
  font-weight: 800;
  background-color: black;
  color: white;
  cursor: pointer;
  &:hover {
    img {
      transform: rotate(360deg);
      transition: 0.8s;
    }
  }
`;
